import { Chakra } from "@airhelp/react-ui-components";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { useTranslations, useLanguage, useLocalizedData } from "contexts/LocalizationContext/hooks";
import config from "config/config";
import getPageUrl from "utils/getPageUrl";
import { useReferralProgramConfig } from "contexts/DataContext/hooks";

const { Text: ChakraText, useTheme } = Chakra;

const StyledChakraText = styled(ChakraText)`
  ${(props) => `
    a {
      color: ${props.colors.primary[500]};
      font-weight: ${props.fontweights.semibold};
    }
  `}
`;

const Text = ({ content, fontWeight }) => {
  const language = useLanguage();
  const translations = useTranslations();
  const { getLocalizedCurrency } = useLocalizedData();
  const { colors, fontWeights } = useTheme();

  const termsHref = `href="${config.websiteUrl}${getPageUrl(language, "referralTerms")}"`;
  const affiliateLink = `<a href="${config.websiteUrl}${getPageUrl(language, "affiliate")}">${
    config.websiteUrl
  }${getPageUrl(language, "affiliate")}</a>`;

  const referralProgramConfig = useReferralProgramConfig();
  const { commissionValue } = referralProgramConfig;

  const translationVariables = {
    "%commission%": getLocalizedCurrency(commissionValue, "EUR"),
    "%terms-link-attrs%": termsHref,
    "%affiliate-link%": affiliateLink,
  };

  const translation = translations(content, translationVariables);

  return (
    <StyledChakraText
      colors={colors}
      fontweights={fontWeights}
      mb={4}
      fontWeight={fontWeight}
      dangerouslySetInnerHTML={{ __html: translation }}
    />
  );
};

export default [
  {
    header: "faq_how_to_invite",
    content: [<Text key="faq_how_to_invite_answer" content="faq_how_to_invite_answer" />],
  },
  {
    header: "faq_how_much_do_i_get",
    content: [
      <Text key="faq_how_much_do_i_get_answer_p1" content="faq_how_much_do_i_get_answer_p1" />,
      <Text key="faq_how_to_invite_answer_p2" content="faq_how_to_invite_answer_p2" />,
    ],
  },
  {
    header: "faq_how_long_link_valid",
    content: [
      <Text key="faq_how_long_link_valid_answer_p1" content="faq_how_long_link_valid_answer_p1" />,
      <Text key="faq_how_long_link_valid_answer_p2" content="faq_how_long_link_valid_answer_p2" />,
    ],
  },
  {
    header: "faq_will_i_receive_reward",
    content: [
      <Text key="faq_will_i_receive_reward_answer_p1" content="faq_will_i_receive_reward_answer_p1" />,
      <Text key="faq_will_i_receive_reward_answer_p2" content="faq_will_i_receive_reward_answer_p2" />,
    ],
  },
  {
    header: "faq_is_there_a_limit",
    content: [
      <Text key="faq_is_there_a_limit_answer_p1" content="faq_is_there_a_limit_answer_p1" />,
      <Text key="faq_is_there_a_limit_answer_p2" content="faq_is_there_a_limit_answer_p2" />,
    ],
  },
  {
    header: "faq_how_to_redeem",
    content: [<Text key="faq_how_to_redeem_answer" content="faq_how_to_redeem_answer" />],
  },
];

Text.propTypes = {
  content: PropTypes.string.isRequired,
  fontWeight: PropTypes.string,
};

Text.defaultProps = {
  fontWeight: "normal",
};
